import { render, staticRenderFns } from "./TokenAuth.vue?vue&type=template&id=04e557b0&"
import script from "./TokenAuth.vue?vue&type=script&lang=ts&"
export * from "./TokenAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports